"use strict";
/**
 * @copyright 2020 Microsoft Corporation
 */
var $dyn;
(function ($dyn) {
    var ax;
    (function (ax) {
        var personalizationUtil;
        (function (personalizationUtil) {
            function canBePersonalizedInCurrentMode(controlName, formName) {
                return ($dyn.ax.formPersonalizationPane.formPersonalizationToolbar.currentPersonalizableControls &&
                    !!$dyn.ax.formPersonalizationPane.formPersonalizationToolbar.currentPersonalizableControls[formName] &&
                    !!$dyn.ax.formPersonalizationPane.formPersonalizationToolbar.currentPersonalizableControls[formName][controlName]);
            }
            personalizationUtil.canBePersonalizedInCurrentMode = canBePersonalizedInCurrentMode;
            function isPersonalizationModeTurnedOn() {
                if ($dyn.ax.formPersonalizationPane &&
                    $dyn.ax.formPersonalizationPane.formPersonalizationToolbar &&
                    $dyn.ax.formPersonalizationPane.formPersonalizationToolbar.Mode &&
                    $dyn.value($dyn.ax.formPersonalizationPane.formPersonalizationToolbar.Mode) !== "") {
                    return true;
                }
                return false;
            }
            personalizationUtil.isPersonalizationModeTurnedOn = isPersonalizationModeTurnedOn;
            function currentPersonalizationMode() {
                if ($dyn.ax.formPersonalizationPane &&
                    $dyn.ax.formPersonalizationPane.formPersonalizationToolbar &&
                    $dyn.ax.formPersonalizationPane.formPersonalizationToolbar.Mode &&
                    $dyn.value($dyn.ax.formPersonalizationPane.formPersonalizationToolbar.Mode)) {
                    return $dyn.value($dyn.ax.formPersonalizationPane.formPersonalizationToolbar.Mode);
                }
            }
            personalizationUtil.currentPersonalizationMode = currentPersonalizationMode;
            function forceUpdateFormPersonalizationData() {
                var toolbar;
                if ($dyn.ax.formPersonalizationPane && $dyn.ax.formPersonalizationPane.formPersonalizationToolbar) {
                    toolbar = $dyn.ax.formPersonalizationPane.formPersonalizationToolbar;
                }
                if (toolbar && toolbar.Mode && toolbar.Mode() !== "") {
                    toolbar.savePendingPersonalizationAndCallUpdatePersonalizationData(true);
                    var partCreatedHandler_1 = function () {
                        $dyn.async(function () {
                            if (toolbar.Mode() !== "") {
                                toolbar.savePendingPersonalizationAndCallUpdatePersonalizationData(true);
                            }
                        });
                    };
                    $(document.body).on($dyn.forms.Events.partCreated, partCreatedHandler_1);
                    var personalizeCloseHandler_1 = function () {
                        $(document.body).off($dyn.forms.Events.partCreated, partCreatedHandler_1);
                        $(window).off($dyn.ui.personalizationToolbarEvents.ToolbarClosed, personalizeCloseHandler_1);
                    };
                    $(window).on($dyn.ui.personalizationToolbarEvents.ToolbarClosed, personalizeCloseHandler_1);
                }
            }
            personalizationUtil.forceUpdateFormPersonalizationData = forceUpdateFormPersonalizationData;
            function checkIfSummaryField(typeName) {
                switch (typeName) {
                    case "InputSummary":
                    case "MultilineInputSummary":
                    case "RealSummary":
                    case "IntegerSummary":
                    case "Int64Summary":
                    case "DateSummary":
                    case "DateTimeSummary":
                    case "TimeSummary":
                    case "ComboBoxSummary":
                        return true;
                    default:
                        return false;
                }
            }
            personalizationUtil.checkIfSummaryField = checkIfSummaryField;
            /**
             * Check if the controlElement has dynBreakableGroups and apply the given className to them.
             * Perform this in a timout to allow for the groups to be broken by layout first.
             * @param controlElement Element with breakable groups
             * @param className Name of class to add or remove
             * @param mode Personalization mode
             * @param remove Remove from class group
             */
            function addClassToBreakableGroups(controlElement, className, mode, remove) {
                if (remove === void 0) { remove = false; }
                setTimeout(function () {
                    var breakableGroups = $dyn.layout.getBreakableGroups(controlElement);
                    breakableGroups.forEach(function (subGroup) {
                        if (remove) {
                            subGroup.classList.remove(className);
                        }
                        else {
                            subGroup.classList.add(className);
                        }
                    });
                });
            }
            personalizationUtil.addClassToBreakableGroups = addClassToBreakableGroups;
            function isActionKey(key) {
                return key === $dyn.ui.KeyCodes.enter || key === $dyn.ui.KeyCodes.spacebar;
            }
            personalizationUtil.isActionKey = isActionKey;
            function isControlPersonalizable(controlContext) {
                return (controlContext.Name === "SysPAMenuButton") ? true : $dyn.value(controlContext.AllowPersonalization);
            }
            personalizationUtil.isControlPersonalizable = isControlPersonalizable;
            function isControlSelectedForMove(control) {
                if (control) {
                    // When control is selected for move then click happens to initiate move and hence target should not be clickable
                    if ($dyn.ax.personalizationUtil.isPersonalizationModeTurnedOn() &&
                        $dyn.ax.formPersonalizationPane.formPersonalizationToolbar &&
                        $dyn.ax.personalizationUtil.currentPersonalizationMode() === $dyn.ax.personalizationMode.move) {
                        var controlElement = $dyn.ax.formPersonalizationPane.formPersonalizationToolbar.getElementOrHeader(control.Name, control.element);
                        if (controlElement && $(controlElement).hasClass($dyn.ui.personalizationClasses.selectedForMove)) {
                            return true;
                        }
                    }
                }
                return false;
            }
            personalizationUtil.isControlSelectedForMove = isControlSelectedForMove;
            function getPersonalizableControl(target) {
                var contextControl = $dyn.ui.getLiveControl(target);
                if (!contextControl) {
                    // If there is not context for the target, check the DOM heirarchy for the closest control.
                    var closestControlElement = $(target).addBack().closest("[data-dyn-controlname]")[0];
                    contextControl = $dyn.ui.getLiveControl(closestControlElement);
                    if (!contextControl) {
                        return null;
                    }
                }
                if (contextControl instanceof $dyn.controls.SectionPageHeader) {
                    // SectionPageHeaders are not personalizable.
                    // Get the SectionPage that this header is for.
                    contextControl = contextControl.GetSectionPage();
                }
                // The control may not be data-bound, in that case there is no context
                // Check the context control's element first, then the event target
                var element;
                if ($dyn.context(contextControl.element)) {
                    element = contextControl.element;
                }
                else if ($dyn.context(target)) {
                    element = target;
                }
                var controlParams;
                var controlName;
                if (element) {
                    controlParams = $dyn.serverForm && $dyn.serverForm.getElementControlParams(element);
                    if (controlParams) {
                        controlName = $dyn.value(controlParams.Name);
                    }
                }
                else {
                    // Fall back on the name passed in in the context control
                    controlName = $dyn.value(contextControl.Name);
                }
                var contextSubControl = contextControl;
                var searchName = controlName ? controlName : $dyn.value(contextControl.Name);
                var subControl = contextControl.Root && contextControl.Root.findControl && contextControl.Root.findControl(searchName);
                if (subControl) {
                    controlParams = $dyn.serverForm && $dyn.serverForm.getElementControlParams(subControl);
                    if (controlParams) {
                        controlName = $dyn.value(controlParams.Name);
                    }
                }
                if (controlParams && controlName && contextControl && contextControl.Root) {
                    // if this is a client-only control composing a server control (i.e. a button within file upload or header of a grid)
                    // redirect the search to the real server control
                    if (!contextControl.Root.findControl) {
                        $dyn.logError("formPersonalization:getPersonalizableControl has a control whose root do not have findcontrol function");
                    }
                    subControl = contextControl.Root.findControl && contextControl.Root.findControl(controlName);
                    if (subControl) {
                        contextSubControl = $dyn.ui.getLiveControl(subControl);
                        controlName = contextSubControl.Name;
                    }
                    else {
                        contextSubControl = null;
                        controlName = "";
                    }
                }
                if (controlName) {
                    var formName = contextSubControl && contextSubControl.Root && contextSubControl.Root.FormName;
                    var canBePersonalizedInThisMode = $dyn.ax.personalizationUtil.canBePersonalizedInCurrentMode(controlName, formName);
                    while (!canBePersonalizedInThisMode &&
                        contextSubControl &&
                        $dyn.ax.formPersonalizationPane.formPersonalizationToolbar.Mode() === $dyn.ax.personalizationMode.move &&
                        !$dyn.ax.personalizationUtil.checkIfSummaryField(contextSubControl.TypeName)) {
                        // Search up for the first personalizable control in this mode.
                        var parentControlElement = $(contextSubControl.element).parents("[data-dyn-controlname]")[0];
                        contextSubControl = $dyn.ui.getLiveControl(parentControlElement);
                        canBePersonalizedInThisMode = contextSubControl && $dyn.ax.personalizationUtil.canBePersonalizedInCurrentMode(contextSubControl.Name, formName);
                    }
                    if (contextSubControl && contextSubControl.Root) {
                        var canPersonalize = !!$dyn.value(contextSubControl.PersistPersonalization) && !!$dyn.value(contextSubControl.ExecutePersonalizationCommand);
                        var controlAllowsPersonalization = $dyn.ax.personalizationUtil.isControlPersonalizable(contextSubControl);
                        var personalizationAllowed = $dyn.value(contextSubControl.Root.AllowExplicitPersonalization) && controlAllowsPersonalization;
                        if (canPersonalize && personalizationAllowed && canBePersonalizedInThisMode) {
                            return contextSubControl;
                        }
                    }
                }
                return null;
            }
            personalizationUtil.getPersonalizableControl = getPersonalizableControl;
            function getPersonalizableAppContainerControl(target) {
                var acceptedRoles = ["AppBarSection", "Section", "VerticalTabs", "Panorama", "Pivot"];
                var parents = $(target).addBack().parents();
                // tslint:disable-next-line:prefer-for-of
                for (var i = 0; i < parents.length; i++) {
                    var currentParent = parents[i];
                    var role_1 = currentParent.getAttribute("data-dyn-role");
                    if (acceptedRoles.indexOf(role_1) !== -1) {
                        var parentContext = $dyn.context(currentParent);
                        if (parentContext && parentContext.Root) {
                            if (role_1 === "Pivot" && !$dyn.value(parentContext.ShowHeaders)) {
                                return null;
                            }
                            var formName = parentContext.Root.FormName;
                            var personalizationAllowed = $dyn.value(parentContext.Root.AllowExplicitPersonalization) && $dyn.value(parentContext.AllowPersonalization);
                            var canBePersonalizedInThisMode = $dyn.ax.personalizationUtil.canBePersonalizedInCurrentMode(parentContext.Name, formName);
                            if (personalizationAllowed && canBePersonalizedInThisMode) {
                                return parentContext;
                            }
                        }
                    }
                }
                return null;
            }
            personalizationUtil.getPersonalizableAppContainerControl = getPersonalizableAppContainerControl;
            function getPersonalizableContainerControl(target) {
                var acceptedRoles = ["List", "ReactList", "Group", "SectionPage"];
                var parents = $(target).addBack().parents();
                // tslint:disable-next-line:prefer-for-of
                for (var i = 0; i < parents.length; i++) {
                    var currentParent = parents[i];
                    var role_2 = currentParent.getAttribute("data-dyn-role");
                    if (acceptedRoles.indexOf(role_2) !== -1) {
                        var parentContext = $dyn.context(currentParent);
                        if (parentContext && parentContext.Root) {
                            var formName = parentContext.Root.FormName;
                            var personalizationAllowed = $dyn.value(parentContext.Root.AllowExplicitPersonalization) && $dyn.value(parentContext.AllowPersonalization);
                            var canBePersonalizedInThisMode = $dyn.ax.personalizationUtil.canBePersonalizedInCurrentMode(parentContext.Name, formName);
                            if (personalizationAllowed && canBePersonalizedInThisMode) {
                                return parentContext;
                            }
                        }
                    }
                }
                return null;
            }
            personalizationUtil.getPersonalizableContainerControl = getPersonalizableContainerControl;
            function throttle(callback, limit, blockThrottledEvents) {
                if (blockThrottledEvents === void 0) { blockThrottledEvents = false; }
                var throttling = false;
                // tslint:disable-next-line:only-arrow-functions
                return function () {
                    if (!throttling) {
                        callback.apply(callback, arguments);
                        throttling = true;
                        setTimeout(function () {
                            throttling = false;
                        }, limit);
                    }
                    else if (blockThrottledEvents) {
                        var event_1 = arguments[0];
                        event_1.stopPropagation();
                        event_1.preventDefault();
                        $dyn.log.stopPropagation && $dyn.log.stopPropagation("Throttle event during Personalization");
                    }
                };
            }
            personalizationUtil.throttle = throttle;
        })(personalizationUtil = ax.personalizationUtil || (ax.personalizationUtil = {}));
    })(ax = $dyn.ax || ($dyn.ax = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=PersonalizationUtil.js.map
